/**
 * @file Constants: audioAssets
 * @description Central configuration for all audio assets used in the game
 */

import { getAssetPath } from '../utils/assetPath';

/**
 * Audio asset paths for all sounds used in the game
 * Using paths from the public directory to ensure they work in both development and production
 */
export const AUDIO_ASSETS = {
  MUSIC: {
    TITLE_SCREEN: getAssetPath('/assets/audio/TitleScore_screens.mp3'),
    GAMEPLAY: getAssetPath('/assets/audio/Race_Against_Time_Balanced.mp3'),
  },
  SFX: {
    COUNTDOWN: getAssetPath('/assets/audio/Countdown.mp3'),
    COUNTDOWN_321: getAssetPath('/assets/audio/321_Countdown.mp3'),
    BUTTON_PRESS: getAssetPath('/assets/audio/Button_press.mp3'),
    CORRECT_TAP: getAssetPath('/assets/audio/Correct_Tap.mp3'),
    WRONG_TAP: getAssetPath('/assets/audio/Wrong_tap.mp3'),
    TAP: getAssetPath('/assets/audio/Tap.mp3'),
    SCENE_OPEN: getAssetPath('/assets/audio/Scene_Open.mp3'),
    SCORE_SUMMARY: getAssetPath('/assets/audio/Score_Summary.mp3'),
    SCORE_UP: getAssetPath('/assets/audio/Score_up.mp3'),
    EVIDENCE_ROOM_UNLOCK: getAssetPath(
      '/assets/audio/Evidence_Room_Unlock.mp3',
    ),
    MINIMUM_EVIDENCE_SECURED: getAssetPath('/assets/audio/Minimum_found.mp3'),
    ROOM_SWIPE: getAssetPath('/assets/audio/Room_swipe.mp3'),
    BADGE_ADDED: getAssetPath('/assets/audio/badge-added.mp3'),
    STAR_DROP: getAssetPath('/assets/audio/star-drop.mp3'),
    NUMBER_ENLARGES: getAssetPath('/assets/audio/number-enlarges.mp3'),
    SCORE_TICKING: getAssetPath('/assets/audio/score-ticking.mp3'),
    OBJECT_SLIDING: getAssetPath('/assets/audio/object-sliding.mp3'),
  },
};

/**
 * Audio category types
 */
export type AudioCategory = 'MUSIC' | 'SFX';

/**
 * Music key types for type safety when referencing music assets
 */
export type MusicKey = keyof typeof AUDIO_ASSETS.MUSIC;

/**
 * Sound effect key types for type safety when referencing SFX assets
 */
export type SfxKey = keyof typeof AUDIO_ASSETS.SFX;
